export default "__VITE_ASSET__V82A1p9u__"